import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class TitleService {
	public readonly title$ = new BehaviorSubject<string | undefined>(undefined);

	private readonly titleHolder: string;

	constructor(private readonly title: Title) {
		// prevents rapid changes to the title, uses latest title change
		this.title$.pipe(debounceTime(100)).subscribe((nextTitle) => {
			this.title.setTitle(nextTitle);
		});
	}

	public setTitle(title: string): void {
		if (title !== this.titleHolder) {
			this.title$.next(title);
		}
	}

	public getTitle(): string {
		return this.titleHolder;
	}
}
